import { Row } from 'antd';
import React, { ReactElement } from 'react';
import { GUTTOR_SPACE, NON_CLASSIFICATION_ERR } from '../../constants/commonConstants';
import { RADIO_SWITCH_OPTION } from '../../constants/crmConstants';
import { FormRadioButton, FormSelect } from '../crmFormElement/FormInput';

const DescrepencyQuestion = ({
  classification, onChangeQuestion, fileNames: options, setFinalAnswer,
}: any): ReactElement => {
  const { questionText, questionType, isSelectFile } = classification;
  return (
    <div className="uploaded-file-list">
      <Row gutter={GUTTOR_SPACE}>
        <FormRadioButton detail={{
          key: questionText,
          size: 12,
          options: [...RADIO_SWITCH_OPTION],
          disabled: false,
          rules: [{required: true, message: NON_CLASSIFICATION_ERR}],
          onChange: onChangeQuestion,
        }} />
        {
          isSelectFile
            ? <FormSelect detail={{
              key: questionType,
              label: 'Select File',
              options,
              size: 12,
              onChange: setFinalAnswer,
              allowClear: false,
              rules: [{required: true, message: 'File selection is required.'}],
            }} />
            : null
        }
      </Row>
    </div>
  );
};

export default DescrepencyQuestion;
